export class Subtopic {
  topic: string;
  checked: boolean = true;

  constructor(topic: string) {
    this.topic = topic;
  }

  public static constructSubtopic(data: any): Subtopic {
    return new Subtopic(data.topic);
  }
}